"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Config_1 = require("./Config");
const analytics_1 = require("../analitics/analytics");
function manageGlobalError() {
    if (Config_1.ENV.browser !== true)
        return;
    window.onerror = function (error, url, line) {
        /* send analytics */
        analytics_1.analyticsTrack('crash', {
            category: 'error',
            label: error.toString(),
        });
        /* reload page? */
        //better not to reload page!
        /*setTimeout(()=>{
            location.reload();
        },1000);*/
    };
}
exports.manageGlobalError = manageGlobalError;
//# sourceMappingURL=ErrorCatching.js.map